import { interfaceAllChareges } from "../../interface/AllChargesInterface";
import { SuccessToastBottom } from "../../components/ToastComponent/SuccessToast";
import Konsole from "../../utils/konsole/Konsole";
// import { ErrorToastBottom } from "../../components/ToastComponent/ErrorToast";

export const SET_CART_DATA = "SET_CART_DATA";
export const SET_CART_TOTAL_PRICE = "SET_CART_TOTAL_PRICE";
export const SET_CART_COUNT = "SET_CART_COUNT";
export const CLEAR_CART = "CLEAR_CART";
export const ALL_CHARGES = "ALL_CHARGES";
export const IS_CART_OPEN = "IS_CART_OPEN";
export const MIN_ORDER_DELIVERY_PRICE = 'MIN_ORDER_DELIVERY_PRICE';
export const SET_TOTAL_COUPON_TOTAL = "SET_TOTAL_COUPON_TOTAL";
export const SET_IS_DISCOUNT_APPLY="SET_IS_DISCOUNT_APPLY";

export const SETISDISCOUNTAPPLY = (value: any) => {
  return {
    type: SET_IS_DISCOUNT_APPLY,
    payload: value,
  };
}

export const SETTOTALCOUPONTOTAL = (amt: any) => {
  return {
    type: SET_TOTAL_COUPON_TOTAL,
    payload: amt,
  };
}

export const SETMINORDERDELIVERYPRICE = (data: any) => {
  return {
    type: MIN_ORDER_DELIVERY_PRICE,
    payload: data,
  };
};

export const SETCARTDATA = (data: any) => {
  return {
    type: SET_CART_DATA,
    payload: data,
  };
};
export const SETCARTOPENSTATUS = (data: any) => {
  sessionStorage.setItem('isCartOpen', `${data}`);
  return {
    type: IS_CART_OPEN,
    payload: data
  }
}

export const SETCARTTOTALPRICE = (data: any) => {
  Konsole.log("set cart", data);
  return {
    type: SET_CART_TOTAL_PRICE,
    payload: data,
  };
};
export const SETCARTCOUNT = (data: any) => {
  return {
    type: SET_CART_COUNT,
    payload: data,
  };
};
export const SETALLCHARGES = (data: interfaceAllChareges) => {
  return {
    type: ALL_CHARGES,
    payload: data,
  };
};
export const CLEARCART = () => {
  return {
    type: CLEAR_CART,
    payload: null,
  };
};
const initialState: any = {
  itemCount: 0,
  totalPrice: 0,
  items: [],
  finalPrice: 0,
  remainingOrder: 0,
  discountAmount: 0,
  serviceFee: 0,
  merServiceFee: 0,

  commissionFee: 0,
  isCartOpen: false,
  deliveryCharge: 0,
  minOrderDeliveryPrice: null,
  discountCouponTotal: 0,
  isDiscountApply:false,
}
Konsole.log('initialState', initialState)
const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {

    case SET_IS_DISCOUNT_APPLY:
      return {
        ...state,
        isDiscountApply:payload,
      }
    case SET_TOTAL_COUPON_TOTAL:
      return {
        ...state,
        discountCouponTotal: payload,
      }
    case SET_CART_DATA:
      return {
        ...state,
        items: payload,
      };
    case SET_CART_TOTAL_PRICE:
      return {
        ...state,
        totalPrice: payload,
      };
    case SET_CART_COUNT:
      Konsole.log('payloadpayload', state, payload)
      if (state?.itemCount < payload) {

        if (sessionStorage.getItem('isCartOpen') != 'true') {
          // let msg = 'Your item has been added to cart'
          // if (payload > 1) {
          //   msg = `${payload} Item has been added to cart`
          // }
          // SuccessToastBottom(msg)
        }
      } else {
        // let msg = '1 item has been removed from cart'
        // if (payload == 1) {
        //   msg = 'Your cart is currently empty.'
        // }
        // ErrorToastBottom(msg);s
      }
      return {
        ...state,
        itemCount: payload,
      };
    case IS_CART_OPEN:
      return {
        ...state,
        isCartOpen: payload,
      }
    case MIN_ORDER_DELIVERY_PRICE:
      return {
        ...state,
        minOrderDeliveryPrice: payload
      }
    case CLEAR_CART:
      sessionStorage.removeItem("items");
      return {
        itemCount: 0,
        totalPrice: 0,
        items: [],
        finalPrice: 0,
        remainingOrder: 0,
        discountAmount: 0,
        serviceFee: 0,
        merServiceFee: 0,
        commissionFee: 0,
        deliveryCharge: 0,
        isCartOpen: false,
        minOrderDeliveryPrice: null

      };
    case ALL_CHARGES:
      return {
        ...state,
        finalPrice: payload.finalPrice,
        remainingOrder: payload.remainingOrder,
        discountAmount: payload.discountAmount,
        serviceFee: payload.serviceFee,
        merServiceFee: payload.merServiceFee || 0,
        commissionFee: payload.commissionFee,
        deliveryCharge: payload.deliveryCharge,
      };

    default:
      return state;
  }
};

export default reducer;
